module.exports = __webpack_public_path__ + "static/img/nuclear-fuel-rod_256.22132f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nuclear-fuel-rod_256.png
// module id = vHU0
// module chunks = 0